// angular.module('HeroPRO')
//   .directive('smartyValidator', smartyValidator);

export default function SmartyValidatorDirective() {
    const directiveSmarty = {
        require: 'ngModel',
        link(scope, elem, attrs, ctrl) {
            scope.$watch(() => {
                if (scope.smartyCtrl.invalid || scope.smartyCtrl.pristine) {
                    ctrl.$setValidity('smarty', false);
                }
                if (scope.smartyCtrl.valid) {
                    ctrl.$setValidity('smarty', true);
                }
            });
        },
    };

    return directiveSmarty;
}



// WEBPACK FOOTER //
// ./src/app/common/smarty/smarty-validator.js